import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as userActions from 'services/api/user';
import { updateAbilities } from 'config/ability';
import { getErrorMessage, parsePagination } from 'utils';

export const fetchUserPrivilegesRequest = () => ({
  type: types.FETCH_USER_PRIVILEGES_REQUEST,
});

const fetchUserPrivilegesSuccess = (payload) => ({
  type: types.FETCH_USER_PRIVILEGES_SUCCESS,
  payload,
});

const fetchUserPrivilegesFailed = (error) => ({
  type: types.FETCH_USER_PRIVILEGES_FAILED,
  error,
});

export const fetchUserPrivileges = (id) => {
  return async (dispatch) => {
    dispatch(fetchUserPrivilegesRequest());

    const response = await userActions.fetchPrivileges(id);

    if (response.ok) {
      updateAbilities(response.data);
      return dispatch(fetchUserPrivilegesSuccess(response.data));
    }

    dispatch(fetchUserPrivilegesFailed());
  };
};

export const fetchUserOrganizationsRequest = () => ({
  type: types.FETCH_USER_ORGANIZATIONS_REQUEST,
});

const fetchUserOrganizationsSuccess = (payload) => ({
  type: types.FETCH_USER_ORGANIZATIONS_SUCCESS,
  payload,
});

const fetchUserOrganizationsFailed = () => ({
  type: types.FETCH_USER_ORGANIZATIONS_FAILED,
});

export const fetchUserOrganizations = (params) => {
  return async (dispatch) => {
    dispatch(fetchUserOrganizationsRequest());

    const response = await userActions.fetchUserOrganizations(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchUserOrganizationsSuccess({
          data: response.data,
          pagination,
        })
      );
    }

    dispatch(fetchUserOrganizationsFailed());
  };
};

// Create user
const createUserRequest = () => ({
  type: types.CREATE_USER_REQUEST,
});

const createUserSuccess = (payload) => ({
  type: types.CREATE_USER_SUCCESS,
  payload,
});

const createUserFailed = (errors) => ({
  type: types.CREATE_USER_FAILED,
  errors,
});

export const createUser = (data) => {
  return async (dispatch) => {
    dispatch(createUserRequest());

    const response = await userActions.createUser(data);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: 'User created successfully',
        })
      );
      return dispatch(createUserSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
      return dispatch(createUserFailed());
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(createUserFailed(errors));
  };
};
/* 
  RESET CREATE USER
 */
const resetCreateUserSuccess = (payload) => ({
  type: types.RESET_CREATE_USER_SUCCESS,
  payload,
});
export const resetCreateUser = () => {
  return async (dispatch) => {
    dispatch(resetCreateUserSuccess());
  };
};
